"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTabs = exports.MaterialTabsUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Tabs_1 = require("material-ui/Tabs");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
require("./tabs.less");
const decorate = material_ui_1.withStyles(theme => ({
    root: {
        height: "22px",
        minWidth: 0,
        marginRight: "30px"
    },
    withPadding: {
        padding: "0 50px"
    },
    label: {
        fontFamily: "Heebo, sans-serif",
        fontSize: "12px",
        letterSpacing: 1.5,
        lineHeight: "14px"
    },
    labelContainer: {
        padding: 0
    },
    rootInheritSelected: {
        color: theme.palette.secondary.light
    },
    wrapper: {
        marginBottom: "6px"
    }
}));
class MaterialTabsUnstyled extends react_1.Component {
    render() {
        const { classes, onAction, onChange, padding, tabs, theme, value } = this.props;
        return (React.createElement(Tabs_1.default, { action: onAction, classes: padding ? { root: classes.withPadding } : undefined, value: value, onChange: onChange, 
            // scrollable
            // scrollButtons="on"
            className: "header-tabs" //C-095.541 
            , indicatorColor: theme.palette.secondary.light }, tabs.map((tab, i) => (React.createElement(Tabs_1.Tab, { className: "super_unique_tab_label", classes: ramda_1.omit(["withPadding"], classes), label: tab.label, key: i, disableRipple: true })))));
    }
}
exports.MaterialTabsUnstyled = MaterialTabsUnstyled;
exports.MaterialTabs = material_ui_1.withTheme()(decorate(MaterialTabsUnstyled));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/tabs/tabs.tsx
// module id = 1927
// module chunks = 0 1 2